import { zodResolver } from "@hookform/resolvers/zod";
import type { FieldValues, Resolver } from "react-hook-form";
import type { ZodTypeAny } from "zod";

/**
 * `@hookform/resolvers@3` resolves its `zod` type peer from the pnpm
 * hoist, which is now zod v4 (pulled in by better-auth), while the app
 * schemas are zod v3. The runtime is compatible; this wrapper bridges
 * the type mismatch in one place.
 */
export function zodFormResolver<T extends FieldValues>(schema: ZodTypeAny): Resolver<T> {
  return zodResolver(schema as unknown as Parameters<typeof zodResolver>[0]) as unknown as Resolver<T>;
}
